export default {
    primary: '#00A8FF',
    secondary: '#013B88',
    background: '#EEEEEE'
}